import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LenderInformationSection",
  props: {
    submissionHistory: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedSubmissionId: null,
      selectedDecision: null
    };
  },
  computed: {
    submissionOptions() {
      var _this$submissionHisto, _this$submissionHisto2, _context, _context2;
      if (!((_this$submissionHisto = this.submissionHistory) != null && (_this$submissionHisto2 = _this$submissionHisto.allIds) != null && _this$submissionHisto2.length)) {
        return [{
          value: null,
          text: ""
        }];
      }
      const eligibleSubmissions = _mapInstanceProperty(_context = this.submissionHistory.allIds).call(_context, id => this.submissionHistory.byId[id]);
      if (!eligibleSubmissions.length) {
        return [{
          value: null,
          text: ""
        }];
      }
      return [{
        value: null,
        text: ""
      }, ..._mapInstanceProperty(_context2 = _sortInstanceProperty(eligibleSubmissions).call(eligibleSubmissions, (a, b) => new Date(b.createdAt) - new Date(a.createdAt))).call(_context2, submission => ({
        value: submission.submissionId,
        text: `${submission.lenderName} — ${this.getDecisionType(submission)} — ${this.formatDate(submission.createdAt)} ${this.formatTime(submission.createdAt)} — ${this.formatLoanAmount(submission)}`
      }))];
    },
    decisionOptions() {
      return [{
        value: null,
        text: ""
      }, {
        value: "approved",
        text: this.$t("global.words.approved")
      }, {
        value: "declined",
        text: this.$t("global.words.declined")
      }];
    },
    isValid() {
      return this.selectedSubmissionId !== null && this.selectedDecision !== null;
    }
  },
  methods: {
    proceed() {
      this.$emit("proceed", {
        submissionId: this.selectedSubmissionId,
        decision: this.selectedDecision
      });
    },
    formatDate(date) {
      var _this$$options$filter;
      return (_this$$options$filter = this.$options.filters) != null && _this$$options$filter.formatDate ? this.$options.filters.formatDate(date) : new Date(date).toLocaleDateString();
    },
    formatTime(date) {
      var _this$$options$filter2;
      return (_this$$options$filter2 = this.$options.filters) != null && _this$$options$filter2.formatDateTimezone ? this.$options.filters.formatDateTimezone(date) : new Date(date).toLocaleTimeString();
    },
    getDecisionType(submission) {
      if (!(submission != null && submission.dealType)) return "";
      return this.$t(`application-form.${submission.dealType}`);
    },
    formatLoanAmount(submission) {
      const amount = submission == null ? void 0 : submission.totalLoanAmount;
      if (!amount) return "";
      const formatted = new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency: "CAD",
        maximumFractionDigits: 0
      }).format(amount);
      return `${formatted}k`;
    }
  }
});